module.exports = __webpack_public_path__ + "img/imgmenu.b47302b6.png";